import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Button,
  Table,
  Label,
  Form,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import axios from "axios"
import ReactPaginate from "react-paginate"
import { ToastContainer, toast } from "react-toastify"
import Select from "react-select"
import { URLS } from "../../Url"

const WhatsappSend = () => {
  const [form, setform] = useState({
    templateName: "",
    description: "",
    sendTo: "",
  })

  const [Noti, setNoti] = useState([])
  console.log(Noti, "getAllNotifications")
  const [customer, setcustomer] = useState([])
  const [Vendor, setVendor] = useState([])
  const [community, setCommunity] = useState([])

  const [selectedMulti, setselectedMulti] = useState([])
  const [selectedMulti1, setselectedMulti1] = useState([])
  const [selectedMulti2, setselectedMulti2] = useState([])

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var datas = data.token
  var Roles = data?.rolesAndPermission[0]

  const handleChange = e => {
    let myUser = { ...form }
    myUser[e.target.name] = e.target.value
    setform(myUser)
  }

  // get all whatsapp notifications
  const getNotifications = () => {
    axios
      .post(
        "https://api.jaininternationalnetwork.com/v1/a2zsolutionsapi/admin/notification/getAllWhatsappNotifications",
        {},
        {
          headers: { Authorization: `Bearer ${datas}` },
        }
      )
      .then(res => {
        setNoti(res.data.notifications)
      })
  }

  const getactivecustomers = () => {
    axios
      .post(
        URLS.GetUserlist,
        {},
        {
          headers: { Authorization: `Bearer ${datas}` },
        }
      )
      .then(res => {
        setcustomer(res.data.activeusers)
      })
      .catch(error => {
        if (error.response && error.response.status === 400) {
          toast(error.response.data.message)
        }
      })
  }

  const getactiveVendor = () => {
    axios
      .post(
        URLS.GetVendor,
        {},
        {
          headers: { Authorization: `Bearer ${datas}` },
        }
      )
      .then(res => {
        setVendor(res.data.activeVendors)
      })
      .catch(error => {
        if (error.response && error.response.status === 400) {
          toast(error.response.data.message)
        }
      })
  }

  // hindu, chirstian, etc...
  const fetchCommunities = () => {
    axios
      .post(
        "https://api.jaininternationalnetwork.com/v1/a2zsolutionsapi/admin/community/getall",
        {},
        { headers: { Authorization: `Bearer ${datas}` } }
      )
      .then(res => {
        if (res.data.success) {
          const userCommunityObjects = res.data.usercommunities.map(
            (community, index) => ({
              _id: `user_${index}`,
              community: community,
            })
          )

          // communities and usercommunities
          const allCommunities = [
            ...(res.data.communities || []),
            ...userCommunityObjects,
          ]
          console.log(userCommunityObjects)
          setCommunity(allCommunities)
        } else {
          toast(res.data.message)
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 400) {
          toast(error.response.data.message)
        }
      })
  }

  useEffect(() => {
    getNotifications()
    getactivecustomers()
    getactiveVendor()
    fetchCommunities()
  }, [])

  const options = customer.map(data => ({
    value: data._id,
    label: data.name,
  }))

  const options1 = Vendor.map(data => ({
    value: data._id,
    label: data.name,
  }))

  const options2 = community.map(data => ({
    value: data._id,
    label: data.community,
  }))

  function handleMulti(data) {
    setselectedMulti(data)
  }

  function handleMulti1(data) {
    setselectedMulti1(data)
  }

  function handleMulti2(data) {
    setselectedMulti2(data)
  }

  // whatsapp adding the notifications
  // const addnotifi = () => {
  //   const selectedValues =
  //     form.sendTo === "User" ? selectedMulti.map(option => option.value) : "All"
  //   const selectedValues1 =
  //     form.sendTo === "Vendor"
  //       ? selectedMulti1.map(option => option.value)
  //       : "All"
  //   const selectedValues2 =
  //     form.sendTo === "Community"
  //       ? selectedMulti2.map(option => option.label)
  //       : "All"
  //   console.log(selectedMulti2)
  //   const dataArray = {
  //     templateName: form.templateName,
  //     sendTo:
  //       form.sendTo === "All"
  //         ? "All"
  //         : form.sendTo === "AllVendors"
  //         ? "Vendor"
  //         : form.sendTo === "AllUsers"
  //         ? "User"
  //         : form.sendTo === "Community"
  //         ? "Community"
  //         : form.sendTo,
  //     users:
  //       form.sendTo === "All"
  //         ? "All"
  //         : form.sendTo === "User"
  //         ? selectedValues
  //         : form.sendTo === "Vendor"
  //         ? selectedValues1
  //         : form.sendTo === "Community"
  //         ? selectedValues2
  //         : "All",
  //   }
  //   axios
  //     .post(
  //       "https://api.jaininternationalnetwork.com/v1/a2zsolutionsapi/admin/notification/addWhatsappNotif",
  //       dataArray,
  //       {
  //         headers: { Authorization: `Bearer ${datas}` },
  //       }
  //     )
  //     .then(res => {
  //       if (res.status === 200) {
  //         toast(res.data.message)
  //         getNotifications()
  //         clearForm()
  //         setselectedMulti([])
  //         setselectedMulti1([])
  //         setselectedMulti2([])
  //       }
  //     })
  //     .catch(error => {
  //       if (error.response && error.response.status === 400) {
  //         toast(error.response.data.message)
  //       }
  //     })
  // }

  const addnotifi = () => {
    const selectedValues =
      form.sendTo === "User" ? selectedMulti.map(option => option.value) : "All"
    const selectedValues1 =
      form.sendTo === "Vendor"
        ? selectedMulti1.map(option => option.value)
        : "All"
    const selectedValues2 =
      form.sendTo === "Community"
        ? selectedMulti2.map(option => option.label)
        : "All"

    const dataArray = {
      templateName: form.templateName,
      sendTo:
        form.sendTo === "All"
          ? "All"
          : form.sendTo === "AllVendors"
          ? "Vendor"
          : form.sendTo === "AllUsers"
          ? "User"
          : form.sendTo === "Community"
          ? "Community"
          : form.sendTo,
      users:
        form.sendTo === "User"
          ? JSON.stringify(selectedValues)
          : form.sendTo === "Vendor"
          ? JSON.stringify(selectedValues1)
          : form.sendTo === "Community"
          ? selectedValues2
          : "All",
    }

    axios
      .post(
        "https://api.jaininternationalnetwork.com/v1/a2zsolutionsapi/admin/notification/addWhatsappNotif",
        dataArray,
        {
          headers: { Authorization: `Bearer ${datas}` },
        }
      )
      .then(res => {
        if (res.status === 200) {
          toast(res.data.message)
          getNotifications()
          clearForm()
          setselectedMulti([])
          setselectedMulti1([])
          setselectedMulti2([])
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 400) {
          toast(error.response.data.message)
        }
      })
  }


  const deletenoti = data => {
    axios
      .delete(URLS.DeleteWhatsappNotifications + data._id, {
        headers: { Authorization: `Bearer ${datas}` },
      })
      .then(res => {
        if (res.status === 200) {
          toast(res.data.message)
          getNotifications()
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 400) {
          toast(error.response.data.message)
        }
      })
  }

  const manageDelete = data => {
    const confirmBox = window.confirm("Do you really want to Delete?")
    if (confirmBox === true) {
      deletenoti(data)
    }
  }

  const handleSubmit = e => {
    e.preventDefault()
    addnotifi()
  }

  const clearForm = () => {
    setform({
      templateName: "",
      description: "",
      sendTo: "",
    })
  }

  const [listPerPage] = useState(5)
  const [pageNumber, setPageNumber] = useState(0)

  const pagesVisited = pageNumber * listPerPage
  const lists = Noti.slice(pagesVisited, pagesVisited + listPerPage)
  const pageCount = Math.ceil(Noti.length / listPerPage)
  const changePage = ({ selected }) => {
    setPageNumber(selected)
  }

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var Roles = data?.rolesAndPermission[0]

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            title="Home"
            breadcrumbItem="Whatsapp Messages"
          />
          <Row>
            <Col md={4}>
              <Card className="p-4">
                <h5>Add Messages</h5>
                <Form onSubmit={handleSubmit}>
                  <div>
                    <div className="mt-3">
                      <Label>Tempalate Name</Label>
                      <span className="text-danger">*</span>
                      <Input
                        value={form.templateName}
                        onChange={handleChange}
                        name="templateName"
                        required
                        type="text"
                        placeholder="Enter Tempalate Name"
                      />
                    </div>
                    <div className="mt-3">
                      <Label>
                        Send To<span className="text-danger">*</span>
                      </Label>
                      <select
                        value={form.sendTo}
                        name="sendTo"
                        onChange={handleChange}
                        className="form-select"
                        required
                      >
                        <option value="">Select</option>
                        <option value="All">All</option>
                        <option value="AllVendors">All Business Man</option>
                        <option value="Vendor">Single Business Man</option>
                        <option value="AllUsers">All Users</option>
                        <option value="User">Single User</option>
                        <option value="Community"> Community</option>
                      </select>
                    </div>
                    {form.sendTo === "User" && (
                      <div className="mt-3">
                        <Label>Single Users</Label>
                        <span className="text-danger">*</span>
                        <Select
                          name="userList"
                          value={selectedMulti}
                          onChange={handleMulti}
                          options={options}
                          required
                          isMulti
                        />
                      </div>
                    )}
                    {form.sendTo === "Vendor" && (
                      <div className="mt-3">
                        <Label>Single Vendors</Label>
                        <span className="text-danger">*</span>
                        <Select
                          name="vendorList"
                          value={selectedMulti1}
                          onChange={handleMulti1}
                          options={options1}
                          required
                          isMulti
                        />
                      </div>
                    )}
                    {form.sendTo === "Community" && (
                      <div className="mt-3">
                        <Label>Single Communities</Label>
                        <span className="text-danger">*</span>
                        <Select
                          name="communityList"
                          value={selectedMulti2}
                          onChange={handleMulti2}
                          options={options2}
                          required
                          isMulti
                        />
                      </div>
                    )}
                  </div>
                  <div className="text-end mt-3">
                    <Button type="submit" color="primary">
                      Submit <i className="bx bx-check-circle"></i>
                    </Button>
                  </div>
                </Form>
              </Card>
            </Col>
            <Col md={8}>
              <Card>
                <CardBody>
                  <h5>Whatsapp Messages List</h5>
                  <div className="table-rep-plugin mt-4 table-responsive">
                    <Table hover bordered responsive>
                      <thead>
                        <tr>
                          <th>Sl.No</th>
                          <th>Date/Time</th>
                          <th>Template Name</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {lists.map((data, key) => (
                          <tr key={key}>
                            <th scope="row">
                              {(pageNumber - 1) * 5 + key + 6}
                            </th>
                            <td>
                              {data.date} / {data.time}
                            </td>
                            <td>{data.templateName}</td>
                            <td style={{ width: "100px" }}>
                              <Button
                                onClick={() => manageDelete(data)}
                                className="btn-sm"
                                color="danger"
                              >
                                <div className="d-flex">
                                  <small>
                                    <i className="bx bx-trash m-1"></i>
                                    Delete
                                  </small>
                                </div>
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    <div className="mt-3" style={{ float: "right" }}>
                      <ReactPaginate
                        previousLabel={"Previous"}
                        nextLabel={"Next"}
                        pageCount={pageCount}
                        onPageChange={changePage}
                        containerClassName={"pagination"}
                        previousLinkClassName={"previousBttn"}
                        nextLinkClassName={"nextBttn"}
                        disabledClassName={"disabled"}
                        activeClassName={"active"}
                        total={lists.length}
                      />
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
        <ToastContainer />
      </div>
    </React.Fragment>
  )
}

export default WhatsappSend
